export const firebaseConfig = {
  apiKey: "AIzaSyCvuJXYm2z2LB_7_KdLc2GzN6vkRbPR8JM",
  authDomain: "plancam-fda56.firebaseapp.com",
  projectId: "plancam-fda56",
  storageBucket: "plancam-fda56.appspot.com",
  messagingSenderId: "107125968278",
  appId: "1:107125968278:web:77af8b97241db5357321b7",
  measurementId: "G-DTNM3YF8WK"
};
export const firebaseConfig1 = {
  apiKey: "AIzaSyC_dHbtTQwvGJ95pAVV-Ut84IKANxpTv4E",
  authDomain: "tour-portal.firebaseapp.com",
  projectId: "tour-portal",
  storageBucket: "tour-portal.appspot.com",
  messagingSenderId: "1003158537389",
  appId: "1:1003158537389:web:729adafb72bede64623224",
  measurementId: "G-8WWEJSGPFD"
};